<!-- <ng-progress color="red" [thick]="true" [showSpinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"></ng-progress> -->
<div id="upload-sku">
    <div class="modal-header">
      <!-- <h6 class="pop-up-title">{{title}}</h6> -->
    </div>
    <div class="select-cart">
      <!-- <label>SELECT CART</label>
      <ng-container *ngIf="comparedValue=='text'">
        <select class="custom-dropdown custom-dropdown-sm" (change)="changeCart($event.target.value)">
          <option *ngFor="let sc of shoppingCarts" [value]="sc.cartId" [selected]="sc.cartId == cartId || sc.cartId == shoppingCarts[0].cartId">CART:{{sc?.cartName}}</option>
        </select>
      </ng-container>
      <ng-container *ngIf="comparedValue=='excel'">
        <select class="custom-dropdown custom-dropdown-sm" (change)="changeCart($event.target.value)">
          <option *ngFor="let sc of shoppingCarts" [value]="sc.cartName" [selected]="sc.cartName == cartName || sc.cartName == shoppingCarts[0].cartName">CART:{{sc?.cartName}}</option>
        </select>
      </ng-container> -->
    </div>
  <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#upload-text" role="tab" aria-controls="pills-home"
        aria-selected="true" (click)="checkRadioButton('text')">
        <input type="radio" value="text" [(ngModel)]="comparedValue">
        Upload Text
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#upload-excel" role="tab" aria-controls="pills-profile"
        aria-selected="false" (click)="checkRadioButton('excel')">
        <input type="radio" value="excel" [(ngModel)]="comparedValue">
        Upload Excel
      </a>
    </li>
  </ul>

  <div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade show active" id="upload-text" role="tabpanel" aria-labelledby="pills-home-tab">
      <div class="upload-content">
        <p>
          <b>GUIDELINES:</b>
          Please enter one stock code per line or use a comma to separate codes on a single line. If your list contains an invalid stock code the cart will not be updated. All valid stock codes will be added to your cart with quantity set to 1.
        </p>
        <div class="enter-code">
          <textarea placeholder="Enter stock codes" onfocus="this.placeholder=''" onblur="this.placeholder='Enter stock codes'" id="stockCodesText" class="pop-up-grey-text" rows="3" cols="50" [(ngModel)]="stockCodes"></textarea>
        </div>
        <div class="button-center">
          <button id="btnUploadText" class="button button-red button-large" (click)="uploadText()">Upload</button>
        </div>
        <div class="clearButtonMargin">
          <a href="javascript:void(0)" class="red-link" (click)="clearText()">Clear All</a>
        </div>
        </div>
    </div>

    <div class="tab-pane fade" id="upload-excel" role="tabpanel" aria-labelledby="pills-profile-tab">
      <div class="upload-content">
        <p>
          <b>GUIDELINES:</b>
          <a class="download-sample" (click)="downloadSampleFile()">Download </a>a sample file that you can modify and upload. Stock codes and quantities must be on the first sheet of the workbook. If your file contains an invalid stock code the cart will not be updated.
        </p>
        <label id="btnUploadExcel" class="button button-red">
          Choose File<input type='file' class="file-display" (change)="onSelectFile($event)">
        </label>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth="420" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
  
</div>
